import styled from 'styled-components'
import { cssMediaQueryBreakpoints } from '../../../config/breakpoints'
import { NoSelectStyles } from '../../../shared/styled/NoSelectStyles.styled'

export const StyledArticleTime = styled.p`
    ${NoSelectStyles}

    ${cssMediaQueryBreakpoints.small} {
        width: 100%;
        text-align: left;
    }

    font-size: 12px;
    font-weight: 400;
    color: ${p => p.theme.articleTimestampColor};
    opacity: 0.6;
    margin-bottom: 6px;
    position: relative;
    bottom: -3px;
`
